import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label", "disabled"]

import { ref } from 'vue';

interface Props {
    ariaLabel: string;
    disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ToolbarIconButton',
  props: {
    ariaLabel: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */
const props = __props;

const emit = __emit;

const buttonEl = ref<HTMLButtonElement | null>(null);

function handleClick(event: MouseEvent) {
    if (props.disabled) return;
    emit('click', event);
}

__expose({
    buttonEl,
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip_app = _resolveDirective("tooltip-app")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    ref_key: "buttonEl",
    ref: buttonEl,
    class: "toolbar-icon-button",
    type: "button",
    "aria-label": props.ariaLabel,
    disabled: props.disabled,
    onClick: handleClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1)), [
    [
      _directive_tooltip_app,
      { value: props.ariaLabel, class: 'tooltip-app', showDelay: 600 },
      void 0,
      { top: true }
    ]
  ])
}
}

})